<template>
    <b-collapse
        class="story-collapse"
        id="story-collapse"
        v-model="visible"
    >
        <div class="content">
            <h3 class="title" v-test:title>
                {{ title }}
            </h3>
            <markdown-content :content="content" />
            <b-button
                variant="link"
                class="close-button"
                v-b-toggle.story-collapse
                v-test:closeBtn
            >
                {{ $snippet('close_story', 'close story') }}
                <app-icon name="plus" alt="" />
            </b-button>
        </div>
    </b-collapse>
</template>

<script>
    import { BCollapse, VBToggle } from 'bootstrap-vue';
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';
    import itsuStoryBus from '../../../lib/itsu-story-bus';

    export default {
        name: 'story-collapse',

        components: { BCollapse, MarkdownContent },

        directives: {
            'b-toggle': VBToggle,
        },

        props: {
            title: {
                type: String,
                required: true,
            },

            content: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                visible: true,
            };
        },

        mounted() {
            itsuStoryBus.$on('open', () => {
                this.visible = true;
            });
        },
    };
</script>

<style lang="scss" scoped>
    .story-collapse.show {
        border-top: 2px solid primary-palette(2);
        border-bottom: 2px solid primary-palette(2);
    }

    .content {
        padding: 64px 0;
        text-align: center;
        @include media-breakpoint-up(sm) {
            padding-left: 30px;
            padding-right: 30px;
        }
        @include media-breakpoint-up(lg) {
            padding: 55px 120px;
        }
    }

    .title {
        font-size: rem(24px);
        line-height: rem(28px);
        margin-bottom: 16px;
        @include media-breakpoint-up(lg) {
            font-size: rem(32px);
            line-height: rem(34px);
        }
    }

    .markdown-content {
        text-align: center;

        ::v-deep p {
            font-size: rem(20px);
            line-height: rem(24px);
            @include media-breakpoint-up(lg) {
                font-size: rem(24px);
                line-height: rem(32px);
            }
        }
    }

    .close-button {
        text-decoration: none;
        text-transform: none;
        font-size: rem(24px);
        line-height: rem(28px);
        text-align: center;
        font-weight: 700;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: $itsu-primary;
        padding: 5px;

        &:hover,
        &:focus-visible,
        &:active {
            border-color: $itsu-primary;
        }

        &:focus {
            box-shadow: none;
        }
    }

    .app-icon {
        transition: all ease-in-out 0.25s;
        margin-left: 8px;
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        padding: 10px;
        border-radius: 50%;
        background-color: secondary-palette(8);
        color: $itsu-primary;
        transform: rotate(-45deg);
        @include media-breakpoint-up(lg) {
            background-color: secondary-palette(7);
        }
    }
</style>
